export const CHANGE_CONTROL_UNLOCKED_ID = 'unlocked'
export const CHANGE_CONTROL_LOCKED_ID = 'locked'
export const CHANGE_CONTROL_ALL_IDS = [CHANGE_CONTROL_LOCKED_ID, CHANGE_CONTROL_UNLOCKED_ID]
